import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'
import i18n from 'i18n'

// ACTIONS

// Sales
const salesDashboardRequested = createAction('dashboard/salesRequested')
const salesDashboardRequestFailed = createAction('dashboard/salesRequestFailed')
const salesDashboardReceived = createAction('dashboard/salesReceived')

const pollingSalesDashboardRequested = createAction('dashboard/pollingSalesRequested')
const pollingSalesDashboardRequestFailed = createAction('dashboard/pollingSalesRequestFailed')
const pollingSalesDashboardReceived = createAction('dashboard/pollingSalesReceived')

// Financials
const financialsDashboardRequested = createAction('dashboard/financialsRequested')
const financialsDashboardRequestFailed = createAction('dashboard/financialsRequestFailed')
const financialsDashboardReceived = createAction('dashboard/financialsReceived')

const pollingFinancialsDashboardRequested = createAction('dashboard/pollingFinancialsRequested')
const pollingFinancialsDashboardRequestFailed = createAction(
  'dashboard/pollingFinancialsRequestFailed'
)
const pollingFinancialsDashboardReceived = createAction('dashboard/pollingFinancialsReceived')

// Competitors
const competitorsDashboardRequested = createAction('dashboard/competitorsRequested')
const competitorsDashboardRequestFailed = createAction('dashboard/competitorsRequestFailed')
const competitorsDashboardReceived = createAction('dashboard/competitorsReceived')

const pollingCompetitorsDashboardRequested = createAction('dashboard/pollingCompetitorsRequested')
const pollingCompetitorsDashboardRequestFailed = createAction(
  'dashboard/pollingCompetitorsRequestFailed'
)
const pollingCompetitorsDashboardReceived = createAction('dashboard/pollingCompetitorsReceived')

const defaultState = {
  data: {},
  loading: false,
  success: false,
  polling: false
}

// REDUCER
export const initialState = {
  competitors: defaultState,
  financials: defaultState,
  sales: defaultState
}

const dashboardReducer = createReducer(initialState, {
  // Sales
  [salesDashboardRequested.type]: (state) => {
    state.sales.loading = true
    state.sales.success = false
  },
  [salesDashboardReceived.type]: (state, action) => {
    state.sales.loading = false
    state.sales.success = true
    state.sales.data = action.payload.data
  },
  [salesDashboardRequestFailed.type]: (state, action) => {
    state.sales.loading = false
    state.sales.success = false
    toast.error(i18n.t(action.payload.message))
  },
  [pollingSalesDashboardRequested.type]: (state) => {
    state.sales.polling = true
  },
  [pollingSalesDashboardRequestFailed.type]: (state, action) => {
    state.sales.polling = false
    toast.error(i18n.t(action.payload.message))
  },
  [pollingSalesDashboardReceived.type]: (state, action) => {
    state.sales.polling = false
    state.sales.data = action.payload.data
  },
  // Financials
  [financialsDashboardRequested.type]: (state) => {
    state.financials.loading = true
    state.financials.success = false
  },
  [financialsDashboardReceived.type]: (state, action) => {
    state.financials.loading = false
    state.financials.success = true
    state.financials.data = action.payload.data
  },
  [financialsDashboardRequestFailed.type]: (state, action) => {
    state.financials.loading = false
    state.financials.success = false
    toast.error(i18n.t(action.payload.message))
  },
  [pollingFinancialsDashboardRequested.type]: (state) => {
    state.financials.polling = true
  },
  [pollingFinancialsDashboardRequestFailed.type]: (state, action) => {
    state.financials.polling = false
    toast.error(i18n.t(action.payload.message))
  },
  [pollingFinancialsDashboardReceived.type]: (state, action) => {
    state.financials.polling = false
    state.financials.data = action.payload.data
  },
  // Competitors
  [competitorsDashboardRequested.type]: (state) => {
    state.competitors.loading = true
    state.competitors.success = false
  },
  [competitorsDashboardReceived.type]: (state, action) => {
    state.competitors.loading = false
    state.competitors.success = true
    state.competitors.data = action.payload.data
  },
  [competitorsDashboardRequestFailed.type]: (state, action) => {
    state.competitors.loading = false
    state.competitors.success = false
    toast.error(i18n.t(action.payload.message))
  },
  [pollingCompetitorsDashboardRequested.type]: (state) => {
    state.competitors.polling = true
  },
  [pollingCompetitorsDashboardRequestFailed.type]: (state, action) => {
    state.competitors.polling = false
    toast.error(i18n.t(action.payload.message))
  },
  [pollingCompetitorsDashboardReceived.type]: (state, action) => {
    state.competitors.polling = false
    state.competitors.data = action.payload.data
  }
})

export default dashboardReducer

// PUBLIC ACTIONS
// Sales
export const loadSalesDashboard = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/sales`,
      onStart: salesDashboardRequested.type,
      onSuccess: salesDashboardReceived.type,
      onError: salesDashboardRequestFailed.type
    })
  )
}

export const pollingSalesDashboard = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/sales`,
      onStart: pollingSalesDashboardRequested.type,
      onSuccess: pollingSalesDashboardReceived.type,
      onError: pollingSalesDashboardRequestFailed.type
    })
  )
}

// Financials
export const loadFinancialsDashboard = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/financials`,
      onStart: financialsDashboardRequested.type,
      onSuccess: financialsDashboardReceived.type,
      onError: financialsDashboardRequestFailed.type
    })
  )
}

export const pollingFinancialsDashboard = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/financials`,
      onStart: pollingFinancialsDashboardRequested.type,
      onSuccess: pollingFinancialsDashboardReceived.type,
      onError: pollingFinancialsDashboardRequestFailed.type
    })
  )
}

// Competitors
export const loadCompetitorsDashboard = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/competitors`,
      onStart: competitorsDashboardRequested.type,
      onSuccess: competitorsDashboardReceived.type,
      onError: competitorsDashboardRequestFailed.type
    })
  )
}

export const pollingCompetitorsDashboard = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/competitors`,
      onStart: pollingCompetitorsDashboardRequested.type,
      onSuccess: pollingCompetitorsDashboardReceived.type,
      onError: pollingCompetitorsDashboardRequestFailed.type
    })
  )
}
